import { render, staticRenderFns } from "./standardAnonymousCta.vue?vue&type=template&id=220b83be&"
import script from "./standardAnonymousCta.vue?vue&type=script&lang=js&"
export * from "./standardAnonymousCta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('220b83be', component.options)
    } else {
      api.reload('220b83be', component.options)
    }
    module.hot.accept("./standardAnonymousCta.vue?vue&type=template&id=220b83be&", function () {
      api.rerender('220b83be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/MyAccount/Scripts/Templates/standardAnonymousCta.vue"
export default component.exports